<div class="auto-cover-specs" [class.is-mobile]="isMobile" [class.single-section]="section !== 'all'">

	<!-- The two dates describe the whole system, so the sheet puts them in a header band above the
	     sections rather than inside Mechanism. -->
	<div class="spec-dates" *ngIf="showSection('mechanism')">
		<div class="spec-date">
			<label>System Install Date</label>
			<input slick-date-picker class="form-control" [(ngModel)]="spec.installationDate" [disabled]="readOnly" />
		</div>
		<div class="spec-date">
			<label>Last Cover Replacement</label>
			<input slick-date-picker class="form-control" [(ngModel)]="spec.lastCoverReplacementDate" [disabled]="readOnly" />
		</div>
	</div>

	<!-- Mechanism -->
	<div class="spec-card mechanism" *ngIf="showSection('mechanism')">
		<div class="spec-card-header">Mechanism</div>
		<div class="spec-card-body">
			<div class="spec-field">
				<label>Manufacturer</label>
				<auto-cover-select label="Manufacturer"
								   [isMobile]="isMobile"
								   [items]="manufacturers"
								   [value]="spec?.manufacturer"
								   [disabled]="readOnly"
								   (valueChange)="onManufacturerChanged($event)"></auto-cover-select>
			</div>

			<div class="spec-field" *ngIf="isOtherManufacturer">
				<label>Manufacturer Name</label>
				<input type="text" class="form-control" [(ngModel)]="spec.manufacturerOther" [disabled]="readOnly" />
			</div>

			<div class="spec-field">
				<label>Model</label>
				<!-- "Other" has no model list on the spec sheet, so it's free text -->
				<auto-cover-select *ngIf="!isOtherManufacturer"
								   label="Model"
								   [isMobile]="isMobile"
								   [items]="models"
								   [(value)]="spec.model"
								   [disabled]="readOnly"></auto-cover-select>
				<input *ngIf="isOtherManufacturer" type="text" class="form-control" [(ngModel)]="spec.model" [disabled]="readOnly" />
			</div>

			<div class="spec-field">
				<label>Pool Type</label>
				<auto-cover-select label="Pool Type"
								   [isMobile]="isMobile"
								   [items]="poolTypes"
								   [(value)]="spec.poolType"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Unit Location</label>
				<auto-cover-select label="Unit Location"
								   [isMobile]="isMobile"
								   [items]="unitLocations"
								   [(value)]="spec.unitLocation"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Track Type</label>
				<auto-cover-select label="Track Type"
								   [isMobile]="isMobile"
								   [items]="trackTypes"
								   [value]="spec?.trackType"
								   [disabled]="readOnly"
								   (valueChange)="onTrackTypeChanged($event)"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Motor Side</label>
				<div class="choice-row">
					<label class="choice" [class.selected]="spec?.motorSide === 'Left'">
						<input type="radio" name="motorSide" value="Left" [(ngModel)]="spec.motorSide" [disabled]="readOnly" /> Left
					</label>
					<label class="choice" [class.selected]="spec?.motorSide === 'Right'">
						<input type="radio" name="motorSide" value="Right" [(ngModel)]="spec.motorSide" [disabled]="readOnly" /> Right
					</label>
				</div>
			</div>

			<div class="spec-field">
				<label>Motor Type</label>
				<auto-cover-select label="Motor Type"
								   [isMobile]="isMobile"
								   [items]="motorTypes"
								   [(value)]="spec.motorType"
								   [disabled]="readOnly"></auto-cover-select>
			</div>
		</div>
	</div>

	<!-- Fabric -->
	<div class="spec-card fabric" *ngIf="showSection('fabric')">
		<div class="spec-card-header">Fabric</div>
		<div class="spec-card-body">
			<div class="spec-field">
				<label>Fabric Color</label>
				<div class="color-swatches">
					<div class="color-swatch" *ngFor="let swatch of fabricColors">
						<div class="chip"
							 [style.background]="swatch.hex"
							 [class.selected]="spec?.fabricColor === swatch.color"
							 (click)="onFabricColorClicked(swatch.color)">
							<i *ngIf="spec?.fabricColor === swatch.color" class="bi bi-check-lg"></i>
						</div>
						<div class="chip-label">{{ swatch.color }}</div>
					</div>
				</div>
			</div>

			<!-- Width first, the way a Latham order lists Track Space before Track Length -->
			<div class="spec-field">
				<label>Fabric Size</label>
				<div class="size-group">
					<div class="size-part">
						<span class="size-caption">Width</span>
						<div class="measure-row">
							<div class="measure">
								<input type="number" inputmode="numeric" class="form-control" [(ngModel)]="spec.widthFeet" [disabled]="readOnly" />
								<span class="unit">Ft</span>
							</div>
							<div class="measure">
								<input type="number" inputmode="decimal" class="form-control" [(ngModel)]="spec.widthInches" [disabled]="readOnly" />
								<span class="unit">In</span>
							</div>
						</div>
					</div>
					<div class="size-part">
						<span class="size-caption">Length</span>
						<div class="measure-row">
							<div class="measure">
								<input type="number" inputmode="numeric" class="form-control" [(ngModel)]="spec.lengthFeet" [disabled]="readOnly" />
								<span class="unit">Ft</span>
							</div>
							<div class="measure">
								<input type="number" inputmode="decimal" class="form-control" [(ngModel)]="spec.lengthInches" [disabled]="readOnly" />
								<span class="unit">In</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Fills itself in like the Slack on a Latham order. Only a value the tech changes is stored;
			     otherwise the replacement quote works out the same standard value. -->
			<div class="spec-field">
				<label>Slack <span class="hint">(inches)</span></label>
				<div class="measure slack-measure">
					<input type="number"
						   inputmode="numeric"
						   class="form-control"
						   [value]="displayedSlack ?? ''"
						   (change)="onSlackChanged($any($event.target).value)"
						   [disabled]="readOnly" />
					<span class="unit">In</span>
				</div>
				<div class="field-note" *ngIf="!isSlackOverridden && calculatedSlack !== null">Latham standard for this width and track type</div>
				<div class="field-note" *ngIf="!isSlackOverridden && calculatedSlack === null">Fills in once Width and Track Type are recorded</div>
				<div class="field-note" *ngIf="isSlackOverridden && calculatedSlack !== null">
					Standard is {{ calculatedSlack }} in.
					<button type="button" class="link-button" *ngIf="!readOnly" (click)="resetSlack()">Use {{ calculatedSlack }} in</button>
				</div>
			</div>

			<div class="spec-field">
				<label>Webbing Type</label>
				<auto-cover-select label="Webbing Type"
								   [isMobile]="isMobile"
								   [items]="webbingTypes"
								   [(value)]="spec.webbingType"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Rope Attachment</label>
				<auto-cover-select label="Rope Attachment"
								   [isMobile]="isMobile"
								   [items]="ropeAttachments"
								   [(value)]="spec.ropeAttachment"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<!-- Two different things: the bar profile, then how the fabric fastens to it -->
			<div class="spec-field">
				<label>Leading Edge Size</label>
				<auto-cover-select label="Leading Edge Size"
								   [isMobile]="isMobile"
								   [items]="leSizes"
								   [(value)]="spec.leSize"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Leading Edge Attachment</label>
				<auto-cover-select label="Leading Edge Attachment"
								   [isMobile]="isMobile"
								   [items]="leAttachments"
								   [(value)]="spec.leAttachment"
								   [disabled]="readOnly"></auto-cover-select>
			</div>
		</div>
	</div>

	<!-- Electronics & Components -->
	<div class="spec-card electronics" *ngIf="showSection('electronics')">
		<div class="spec-card-header">Electronics &amp; Components</div>
		<div class="spec-card-body">
			<div class="spec-field">
				<label>Switch Type</label>
				<auto-cover-select label="Switch Type"
								   [isMobile]="isMobile"
								   [items]="switchTypes"
								   [(value)]="spec.switchType"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Water Feature</label>
				<div class="choice-row">
					<label class="choice" [class.selected]="spec?.waterFeature === true">
						<input type="radio" name="waterFeature" [value]="true" [(ngModel)]="spec.waterFeature" [disabled]="readOnly" /> Yes
					</label>
					<label class="choice" [class.selected]="spec?.waterFeature === false">
						<input type="radio" name="waterFeature" [value]="false" [(ngModel)]="spec.waterFeature" [disabled]="readOnly" /> No
					</label>
				</div>
			</div>

			<div class="spec-field">
				<label>Sliders</label>
				<!-- Spec'd as a pop-up picture selector rather than a dropdown -->
				<button type="button" class="picture-trigger" [disabled]="readOnly" (click)="openPicturePicker('sliders')">
					<span class="picture-trigger-thumb">
						<img *ngIf="hasPicture(selectedSlider)" [src]="selectedSlider.imageUrl" [alt]="selectedSlider.text" (error)="onPictureMissing(selectedSlider)" />
						<i *ngIf="!hasPicture(selectedSlider)" class="bi bi-image"></i>
					</span>
					<span class="picture-trigger-text">{{ selectedSlider?.text || 'Choose slider' }}</span>
					<i class="bi bi-chevron-right"></i>
				</button>
			</div>

			<!-- Same picture selector as Sliders, offering only the guide feeds made for the recorded
			     system and track type -->
			<div class="spec-field">
				<label>Guide Feeds</label>
				<button type="button" class="picture-trigger" [disabled]="readOnly" (click)="openPicturePicker('guideFeedType')">
					<span class="picture-trigger-thumb">
						<img *ngIf="hasPicture(selectedGuideFeed)" [src]="selectedGuideFeed.imageUrl" [alt]="selectedGuideFeed.text" (error)="onPictureMissing(selectedGuideFeed)" />
						<i *ngIf="!hasPicture(selectedGuideFeed)" class="bi bi-image"></i>
					</span>
					<span class="picture-trigger-text">{{ selectedGuideFeed?.text || 'Choose guide feed' }}</span>
					<i class="bi bi-chevron-right"></i>
				</button>
				<div class="field-note" *ngIf="!spec?.manufacturer || !spec?.trackType">
					Record the manufacturer and track type to narrow these down
				</div>
			</div>
		</div>
	</div>

	<!-- Box & Lid -->
	<div class="spec-card box-lid" *ngIf="showSection('boxLid')">
		<div class="spec-card-header">Box &amp; Lid</div>
		<div class="spec-card-body">
			<div class="spec-field">
				<label>Lid Type</label>
				<auto-cover-select label="Lid Type"
								   [isMobile]="isMobile"
								   [items]="lidTypes"
								   [(value)]="spec.lidType"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<div class="spec-field">
				<label>Housing Type</label>
				<auto-cover-select label="Housing Type"
								   [isMobile]="isMobile"
								   [items]="housingTypes"
								   [(value)]="spec.housingType"
								   [disabled]="readOnly"></auto-cover-select>
			</div>

			<!-- Every box size is feet and inches, stored as inches -->
			<div class="spec-field">
				<label>Housing Size</label>
				<div class="size-group">
					<ng-container *ngTemplateOutlet="feetInches; context: { field: 'housingLength', caption: 'Length' }"></ng-container>
					<ng-container *ngTemplateOutlet="feetInches; context: { field: 'housingWidth', caption: 'Width' }"></ng-container>
					<ng-container *ngTemplateOutlet="feetInches; context: { field: 'housingDepth', caption: 'Depth' }"></ng-container>
				</div>
			</div>

			<div class="spec-field">
				<label>Track Offset</label>
				<div class="size-group">
					<ng-container *ngTemplateOutlet="feetInches; context: { field: 'motorSideOffset', caption: 'Motor Side' }"></ng-container>
					<ng-container *ngTemplateOutlet="feetInches; context: { field: 'nonMotorSideOffset', caption: 'Non-Motor Side' }"></ng-container>
				</div>
			</div>
		</div>
	</div>

	<ng-template #feetInches let-field="field" let-caption="caption">
		<div class="size-part">
			<span class="size-caption">{{ caption }}</span>
			<div class="measure-row">
				<div class="measure">
					<input type="number"
						   inputmode="numeric"
						   class="form-control"
						   [ngModel]="boxFeet(field)"
						   (ngModelChange)="onBoxFeetChanged(field, $event)"
						   [disabled]="readOnly" />
					<span class="unit">Ft</span>
				</div>
				<div class="measure">
					<input type="number"
						   inputmode="decimal"
						   class="form-control"
						   [ngModel]="boxInches(field)"
						   (ngModelChange)="onBoxInchesChanged(field, $event)"
						   [disabled]="readOnly" />
					<span class="unit">In</span>
				</div>
			</div>
		</div>
	</ng-template>

	<!-- Slider and Guide Feed picture selector. Plain markup rather than a bootstrap or Ionic modal so the
	     one component works unchanged on desktop and mobile. -->
	<div class="picture-picker-backdrop" *ngIf="pictureField" (click)="closePicturePicker()">
		<div class="picture-picker" (click)="$event.stopPropagation()">
			<div class="picture-picker-header">
				<span>{{ pictureTitle }}</span>
				<i class="bi bi-x-lg" (click)="closePicturePicker()"></i>
			</div>
			<div class="picture-picker-grid">
				<div class="picture-tile" *ngFor="let option of pictureOptions"
					 [class.selected]="pictureValue === option.id"
					 (click)="onPicturePicked(option)">
					<div class="picture-tile-image">
						<img *ngIf="hasPicture(option)" [src]="option.imageUrl" [alt]="option.text" loading="lazy" decoding="async" (error)="onPictureMissing(option)" />
						<i *ngIf="!hasPicture(option)" class="bi bi-image"></i>
					</div>
					<div class="picture-tile-label">{{ option.text }}</div>
				</div>
			</div>
		</div>
	</div>

</div>
